"use client";

import React from "react";
import LoginForm from "@/components/forms/LoginForm";
import AuthShell from "@/components/auth/AuthShell";

const Login: React.FC = (): React.JSX.Element => (
  <AuthShell>
    <LoginForm />
  </AuthShell>
);

export default Login;
